import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
const InActiveLogoutScreen = memo(() => {
    return (
        <Div className='d-flex justify-content-center align-content-center ' style={{ height: "70vh" }}>
            <div className="main  justify-content-center align-content-center ">
                <h3 className='mt-4'>
                    Your account is logout due to inactive
                </h3>
                <div className="d-flex mt-4 justify-content-center align-content-center">
                    <Link to={'/login'} className="btn btn-success  text-white" > Login </Link>
                </div>
            </div>
        </Div>
    )
})

export default InActiveLogoutScreen

const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    &>.main{
        background: lightgray;
        padding: 20px;
        border-radius:10px;
        height: 30vh;
    }
`